import { CurrencyISO } from '@guiker/shared-framework'
import { yup } from '@guiker/shared-framework'

export const stockSchema = yup.object({
  currency: yup.mixed<CurrencyISO>().oneOf(Object.values(CurrencyISO)).default(CurrencyISO.CAD),
  label: yup.string().required(),
  tickerSymbol: yup.string().required(),
})
